import React from 'react';
import { Interest } from '../../../types/matching';

interface ProfileInterestsProps {
  interests: Interest[];
}

export function ProfileInterests({ interests }: ProfileInterestsProps) {
  return (
    <div>
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-3 flex items-center gap-2">
        <div className="p-1.5 bg-primary-50 dark:bg-primary-900/20 rounded-lg">
          <span className="text-xl">🌟</span>
        </div>
        <span>Centres d'intérêt</span>
      </h3>
      <div className="flex flex-wrap gap-2 sm:gap-3">
        {interests.length === 0 ? (
          <p className="text-sm text-gray-500 dark:text-gray-400 italic">
            Aucun centre d'intérêt renseigné
          </p>
        ) : (
          interests.map((interest) => (
            <div
              key={interest.id}
              className="flex items-center gap-2 px-3 py-2 bg-gradient-to-br from-accent-50 to-white dark:from-accent-900/20 dark:to-gray-800 rounded-lg shadow-sm border border-accent-100/70 dark:border-accent-800/30"
            >
              <span className="text-lg sm:text-xl">{interest.icon}</span>
              <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                {interest.name}
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
}